import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type modulePermission = {
  module: string;
  disabled: boolean;
};

type ModulePermissionsSlice = {
  permissions: modulePermission[];
};

const initialState: ModulePermissionsSlice = {
  permissions: [],
};

export const modulePermissionsSlice = createSlice({
  name: 'modulePermissions',
  initialState: initialState,
  reducers: {
    setPermissions(state, action: PayloadAction<modulePermission[]>) {
      state.permissions = action.payload;
    },
  },
  selectors: {
    selectPermissions: (state) => state.permissions,
  },
});
